<template>
  <div class="base-input-password-type-1">
    <label class="label">
      {{ label }}
      <input
        class="input"
        type="password"
        v-on="listeners"
        :placeholder="placeholder"
      />
    </label>
  </div>
</template>

<script>
export default {
  name: 'base-input-password-type-1',
  props: {
    label: {
      default: 'LABEL',
      type: String
    },
    placeholder: {
      default: 'INPUT',
      type: String
    }
  },
  computed: {
    listeners() {
      return {
        ...this.$listeners
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.base-input-password-type-1 {
  width: 100%;
  .label {
    width: inherit;
    font-weight: 600;
  }
  .input {
    width: calc(100% - 20px);
    padding: 0 10px;
    height: 50px;
    font-size: 14px;
    font-weight: 300;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 1px;
    color: #000000;
    margin: 10px 0 0 0;
    background-color: #ffffff;
    border: solid 1px #e7e7e7;
    outline: none;
  }
}
</style>
